import {QUERY_CONFIG} from '@/shared/constants.ts';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ReactNode} from 'react';

// Create a client with configured defaults
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: QUERY_CONFIG.STALE_TIME_30_SECONDS,
            gcTime: QUERY_CONFIG.GC_TIME_MS,
            retry: 5,
            refetchOnWindowFocus: true,
        },
    },
});

type QueryProviderProps = {
    children: ReactNode;
};

export const QueryProvider = ({children}: QueryProviderProps) => {
    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
